import React, { Component } from 'react';
import { Banner } from '../../Components'
import Options from './Options'

class componentName extends Component {

    componentDidMount() {
        window.scrollTo(0,0)
    }
    
    render() {
        return (
            <div className="tos">
                <Banner title="Disclaimer" subtitle="Terms Governing this Website (GPbook.com.au)" />
                <div className="page container">

                    <Options />

                    <h4>Disclaimer</h4>
                    <br />
                    <p>
                        While all reasonable care has been taken in the preparation of the material contained in this website, GPbook does not warrant the accuracy, completeness or adequacy of the information in this website. The information is by way of general commentary only, subject to change without notice, and does not constitute the giving of advice.
                    </p>
                    <br />
                    <p>
                        GPbook does not warrant that this website, or any attachment to it, is free from computer viruses. GPbook has no control over the contents of websites maintained by third parties, which may be accessible through websites maintained by GPbook and makes no representation or warranty with respect to such websites or any information on such websites.</p>
                    <br />
                    <p>
                        To the extent permitted by law, GPbook, its employees and agents disclaim liability (including liability by reason of negligence) to any person for any loss, damage, cost or expense incurred or arising as a result of any information, whether by reason of any error, omission or misrepresentation in the information or for any action taken by any person in reliance upon the information contained within this website or any other website which may be accessed through this website. You should seek specific professional advice before acting or refraining from acting on the basis of any of the information contained within this website or any other website which may be accessed through this website."</p>
                </div>
            </div>
        );
    }
}

export default componentName;


// WEBPACK FOOTER //
// ./src/Containers/About/Disclaimer.js